import * as React from 'react';
import { useRef } from 'react';
import { Button } from 'reactstrap';
import Swal from 'sweetalert2';

export function GenericFileUploader(props: {
    actionType: string;
    entityType: string,
    entityId: string,
    uploadLegend: string;
    fileExtensions: string;  // ex: ".xml;.pdf;.jpg"   etc   
    icon: string;
    isEnabled: boolean;
    uploadedFile: File | undefined
    clickAction: (actionType: string, entityType: string, entityId: string, uploadedFile: File | undefined) => void
}) {
    // reference to input type file
    const openFileRef = useRef<any>();

    const adobeFileCompressionLink = '<b><a style="text-decoration: underline; color: blue;" href="https://www.adobe.com/acrobat/online/compress-pdf.html"'
                                        + 'target="_blank"' + ' >Adobe File Compression Tool</a></b>'

    const handleClick = function (event: any) {
        // Open file dialog
        openFileRef.current.click();
    }
    const getLegendText = function (leg: string): string {
        return leg.split("|")[0];
    }
    const getNoteText = function (leg: string): string {
        var parts: string[] = leg.split("|");
        if (parts.length < 2) {
            return "";
        }
        return parts[1];
    }
    const handleChange = function (event: any) {

        const file: File | undefined = event.target.files[0];
        if (!file) { alert("Please select a file."); }

        if (file) {
            if (file.size > 100000000) {
                if (file.type == "application/pdf") {
                    Swal.fire('The PDF File Is Too Large',
                        'Please consider using the following ' + adobeFileCompressionLink + ' to compress your file.',
                        'error');
                } else {
                    Swal.fire('File Too Large', 'Please upload a smaller file.', 'error');
                }
            }
            else {
                openFileRef.current.value = "";
                // Return back to the caller for processing
                props.clickAction(props.actionType, props.entityType, props.entityId, file)
            }
        }

    }

    return (
        <div className="my-3">
            <Button className="mr-3 btn btn-success" disabled={!props.isEnabled}
                onClick={handleClick}
            ><i className={props.icon}></i>
            </Button>
            {getLegendText(props.uploadLegend)}
            <input
                ref={openFileRef}
                type="file"
                style={{ display: 'none' }}
                accept={props.fileExtensions}
                onChange={handleChange}
            />
            { getNoteText(props.uploadLegend).length === 0
                ?
                <></>
                :
                <p><strong>Note:</strong> {getNoteText(props.uploadLegend)}</p>
            }
        </div>
    );
}